const groupBy = (array, keyFn) => {
  return array.reduce((acc, value) => {
    const existing = acc[keyFn(value)] || [];
    acc[keyFn(value)] = existing.concat([value]);
    return acc;
  }, {});
};

export default groupBy;
